import React, { useContext } from 'react';

import {
  MediaTrackingEventComponentLevelData,
  MediaTrackingSource,
} from '@tracker/mediaTracking/mediaTrackingModel';

export interface IMediaTrackingContext {
  isTrackingEnabled: boolean;
  source: MediaTrackingSource;
  trackEvent: (eventData: MediaTrackingEventComponentLevelData) => void;
}

export const MediaTrackingContext = React.createContext<IMediaTrackingContext>({
  source: MediaTrackingSource.NO_SOURCE,
  isTrackingEnabled: false,
  trackEvent: (eventData: MediaTrackingEventComponentLevelData) => {
    return;
  },
});

export const useMediaTrackingContext = () => {
  return useContext(MediaTrackingContext);
};
